import React, { useState } from "react";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import Enter from "../enter/enter";
import Requestmanage from "../requestma/requestmanage";
const Hodoremp = ({ userData }) => {
  const [key, setKey] = useState("enter");
  return (
    <div className="main">
      <Container>
        <h4 className="text-center">إدارة حضور و انصراف الموظف</h4>
        <Row>
          <div className="col-md-12">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3">
              <Tab eventKey="enter" title=" حضور وانصراف">
                <Enter userData={userData} />
              </Tab>
              {userData.roleName === "Employee" ? (
                <Tab eventKey="money" title="طلب إداري">
                  <Requestmanage userData={userData} />
                </Tab>
              ) : null}
              {/* <Tab eventKey="display" title="عرض">
            <Display/>
                </Tab> */}
            </Tabs>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Hodoremp;
